import React, { useState } from 'react';
import MyEmployeesSection from './MyEmployeesSection';
import EmployeeGradingSection from './employeeGrading/EmployeeGradingSection';
import './EmployeesSection.css';

type EmployeesTab = 'list' | 'grading';

export default function EmployeesSection() {
  const [tab, setTab] = useState<EmployeesTab>('list');

  return (
    <div className="employees-section">
      <div className="employees-section-tabs" role="tablist" aria-label="Раздел сотрудников">
        <button
          type="button"
          role="tab"
          aria-selected={tab === 'list'}
          className={`employees-section-tab${tab === 'list' ? ' employees-section-tab-active' : ''}`}
          onClick={() => setTab('list')}
        >
          <i className="fas fa-users" aria-hidden="true" />
          Мои сотрудники
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={tab === 'grading'}
          className={`employees-section-tab${tab === 'grading' ? ' employees-section-tab-active' : ''}`}
          onClick={() => setTab('grading')}
        >
          <i className="fas fa-layer-group" aria-hidden="true" />
          Грейдирование
        </button>
      </div>

      <div role="tabpanel">
        {tab === 'list' ? <MyEmployeesSection embedded /> : <EmployeeGradingSection />}
      </div>
    </div>
  );
}
